import React from 'react'
import { useComplianceFrameworks } from 'src/components/async/complianceframework/useComplianceFrameworks'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

// Filter by compliance framework name - use unique id for the filter value
export const FrameworkNameFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const { data, isLoading, error } = useComplianceFrameworks(true)
    if (error) return <></>
    const frameworks = data?.getItemsList() || []
    const filterValues = frameworks.map((cf) => ({
      value: cf.getId(),
      label: cf.getName(),
    }))

    return (
      <FilterDropdown
        filterParam={FilterParam.NAME}
        filterName={FilterName.NAME}
        filterValues={filterValues}
        isLoading={!data || isLoading}
        isNested={isNested}
      />
    )
  },
)
